const masteringHR = {
    "view": {
        "table": {
            "title": "Vaša lista masteringa",
            "column": {
                "created_by": "Kreirao",
                "total_songs": "Broj pjesama",
                "mastered_songs": "Ukupno masteriranih pjesama",
                "created": "Datum kreiranja",
                "action": "Akcija"
            },
            "button": {
                "open": "OTVORI",
                "edit": "UREDI",
                "export_csv": "Izvezi CSV"
            },
            "placeholder": {
                "search": "Pretraži..."
            }
        },
        "message": {
            "noAccess": "Nemate pristup ovom modulu, molimo kontaktirajte podršku za više informacija.",
            "subscriptionExpired": "Vaša pretplata je istekla. Molimo <1>obnovite</1> pretplatu kako biste koristili ovu značajku.",
            "subscriptionUpgrade": "Vaš trenutni plan pretplate ne podržava ovu značajku. Molimo <1>nadogradite</1> plan pretplate kako biste koristili ovu značajku.",
            "noCredits": "Nemate više kredita za audio mastering. Saznajte više o kreditima <1>ovdje</1> i kontaktirajte naš tim za podršku.",
            "learnMore": "Saznajte sve o Audio Masteringu <1>ovdje</1>. Za više informacija i <3>kredita</3>, kontaktirajte naš tim za podršku."
        }
    },
    "add": {
        "form": {
            "step1": {
                "title": "Koliko pjesama želite masterirati?",
                "label": {
                    "number_of_songs": "Broj pjesama"
                },
                "option": {
                    "songsCount": {
                        "selectNoOfSongs": "Odaberite broj pjesama",
                        "song": "Pjesma",
                        "songs": "Pjesme"
                    }
                },
                "button": {
                    "continue": "Nastavi"
                }
            },
            "step2": {
                "title": "Odaberite svoje pjesme za mastering",
                "button": {
                    "save": "Spremi"
                }
            }
        },
        "message": {
            "uploadSuccess": "Pjesme za audio mastering uspješno prenesene!",
            "creationSuccess": "Audio mastering je kreiran! Sada odaberite svoje pjesme u donjem dijelu.",
            "error": "Došlo je do pogreške. Molimo pokušajte ponovno."
        },
        "modal": {
            "addMastering": {
                "header": "Jeste li sigurni da želite dodati novi mastering?",
                "body": "Napomena: Ovo će rezultirati oduzimanjem {{credits}} kredita."
            },
            "saveMastering": {
                "header": "Jeste li sigurni da želite spremiti Audio Mastering?",
                "body": "Napomena: Molimo provjerite da ste prenijeli ispravne audio datoteke jer ih nije moguće mijenjati nakon spremanja."
            }
        }
    },
    "update": {
        "form": {
            "label": {
                "selectSongs": "Odaberite svoje pjesme za mastering"
            },
            "button": {
                "save": "Spremi"
            }
        },
        "message": {
            "success": "Audio mastering uspješno ažuriran!",
            "errorCantUpdate": "Audio mastering se ne može ažurirati nakon što su pjesme prenesene!",
            "errorMasteringDoesNotExist": "Mastering se ne može ažurirati jer ne postoji!",
            "error": "Došlo je do pogreške. Molimo pokušajte ponovno."
        },
        "modal": {
            "saveMastering": {
                "header": "Jeste li sigurni da želite spremiti Audio Mastering?",
                "body": "Napomena: Molimo provjerite da ste prenijeli ispravne audio datoteke jer ih nije moguće mijenjati nakon spremanja."
            }
        }
    },
    "viewSongs": {
        "title": "Pjesme za audio mastering",
        "table": {
            "column": {
                "name": "Ime",
                "preset": "Preset",
                "intensityAndLoudness": "Intenzitet i glasnoća",
                "preview": "Pregled",
                "master": "Master",
                "previewResult": "Rezultat pregleda",
                "masteringResult": "Rezultat masteringa",
                "mastered": "Masterirano",
                "action": "Akcija"
            },
            "label": {
                "previewAttemptsLeft": "{{count}} preostalo",
                "notAvailable": "Nije dostupno"
            },
            "button": {
                "generate": "Generiraj",
                "edit": "Uredi",
                "exportCsv": "Izvezi CSV"
            },
            "option": {
                "preset": {
                    "acoustic": "Akustično",
                    "allGenres": "Svi žanrovi",
                    "classical": "Klasično",
                    "clubHouseTechno": "Klub - House - Techno",
                    "edmMusic": "EDM glazba",
                    "electronic": "Elektronička",
                    "electronicRaw": "Elektronička sirova",
                    "hipHop": "Hip Hop",
                    "hipHopBass": "Hip Hop Bass",
                    "popMusic": "Pop glazba",
                    "popRnB": "Pop & RnB",
                    "rockMetal": "Rock & Metal",
                    "trap": "Trap",
                    "vocalFocused": "Fokusirano na vokal"
                }
            },
            "message": {
                "previewDownloadTooltip": "Pregled se generira. Molimo pričekajte 5-6 minuta da se pojavi.",
                "masteringDownloadTooltip": "Mastering je u procesu. Molimo pričekajte 7-15 minuta da se pojavi.",
                "alreadyMasteredTooltip": "Ova pjesma je već masterirana."
            }
        },
        "message": {
            "error": "Nešto je pošlo po zlu! Molimo osvježite stranicu i pokušajte ponovno!",
            "successMaster": "Pjesma poslana za generiranje masteringa!<br/>Napomena: Molimo provjerite za nekoliko minuta jer generiranje masteringa traje 7-15 minuta.",
            "successPreview": "Pjesma poslana za generiranje pregleda masteringa!<br/>Napomena: Molimo provjerite za nekoliko minuta jer generiranje pregleda masteringa traje 5-6 minuta."
        },
        "modal": {
            "generateMastering": {
                "header": "Generiraj mastering",
                "body": "Jeste li sigurni da želite generirati mastering? Ovo je nepovratna akcija! Rezultat masteringa će se pojaviti unutar 7-15 minuta.",
                "message": {
                    "success": "Pjesma poslana za generiranje masteringa!"
                }
            },
            "generateMasteringPreview": {
                "header": "Generiraj pregled masteringa",
                "body": "Jeste li sigurni da želite generirati pregled masteringa? Rezultat pregleda će se pojaviti unutar 5-6 minuta",
                "message": {
                    "success": "Pjesma poslana za generiranje pregleda masteringa!"
                }
            }
        }
    },
    "songParametersUpdate": {
        "title": "Uredi parametre pjesme",
        "form": {
            "label": {
                "intensity": "Intenzitet",
                "loudness": "Glasnoća",
                "preset": "Preset"
            },
            "placeholder": {
                "preset": "Odaberite preset"
            },
            "option": {
                "preset": {
                    "acoustic": "Akustično",
                    "allGenres": "Svi žanrovi",
                    "classical": "Klasično",
                    "clubHouseTechno": "Klub - House - Techno",
                    "edmMusic": "EDM glazba",
                    "electronic": "Elektronička",
                    "electronicRaw": "Elektronička sirova",
                    "hipHop": "Hip Hop",
                    "hipHopBass": "Hip Hop Bass",
                    "popMusic": "Pop glazba",
                    "popRnB": "Pop & RnB",
                    "rockMetal": "Rock & Metal",
                    "trap": "Trap",
                    "vocalFocused": "Fokusirano na vokal"
                }
            },
            "button": {
                "submit": "Pošalji"
            },
            "message": {
                "intensityTooltip": "Količina dinamike, EQ-a i obrade primijenjene na vašu pjesmu u odnosu na cijelu pjesmu i odabrani preset. Maksimalna iskorištenost će se dogoditi na 100 %. Preporučujemo eksperimentiranje s ovom postavkom kako biste pronašli najbolju opciju za vas.",
                "loudnessTooltip": "Integrirana ciljna razina glasnoće. Mjereno u jedinicama glasnoće u odnosu na punu skalu (LUFS). Preporučujemo eksperimentiranje s ovom postavkom kako biste pronašli najbolju opciju za vas. Ovisno o stilu i žanru vaše pjesme, najbolji rezultati bi trebali biti između -15 do -9 db"
            }
        },
        "message": {
            "success": "Parametri pjesme su ažurirani!",
            "error": "Nešto je pošlo po zlu! Molimo osvježite stranicu i pokušajte ponovno!",
            "songMastered": "Parametri pjesme se ne mogu ažurirati nakon što je pjesma masterirana!"
        }
    },
    "songRow": {
        "label": {
            "songs": "Pjesme",
            "name": "Ime",
            "genre": "Žanr",
            "preset": "Preset",
            "intensity": "Intenzitet",
            "loudness": "Glasnoća",
            "audioFile": "Audio datoteka"
        },
        "placeholder": {
            "name": "npr. Ime pjesme",
            "genre": "npr. Pop",
            "preset": "Odaberite preset"
        },
        "option": {
            "preset": {
                "acoustic": "Akustično",
                "allGenres": "Svi žanrovi",
                "classical": "Klasično",
                "clubHouseTechno": "Klub - House - Techno",
                "edmMusic": "EDM glazba",
                "electronic": "Elektronička",
                "electronicRaw": "Elektronička sirova",
                "hipHop": "Hip Hop",
                "hipHopBass": "Hip Hop Bass",
                "popMusic": "Pop glazba",
                "popRnB": "Pop & RnB",
                "rockMetal": "Rock & Metal",
                "trap": "Trap",
                "vocalFocused": "Fokusirano na vokal"
            }
        },
        "message": {
            "intensityTooltip": "Količina dinamike, EQ-a i obrade primijenjene na vašu pjesmu u odnosu na cijelu pjesmu i odabrani preset. Maksimalna iskorištenost će se dogoditi na 100 %. Preporučujemo eksperimentiranje s ovom postavkom kako biste pronašli najbolju opciju za vas.",
            "loudnessTooltip": "Integrirana ciljna razina glasnoće. Mjereno u jedinicama glasnoće u odnosu na punu skalu (LUFS). Preporučujemo eksperimentiranje s ovom postavkom kako biste pronašli najbolju opciju za vas. Ovisno o stilu i žanru vaše pjesme, najbolji rezultati bi trebali biti između -15 do -9 db",
            "audioFileTooltip": "Podržani audio formati su: AAC, AIFF, FLAC, MP3, OPUS, VORBIS i WAV. Preporučujemo korištenje formata bez gubitaka kao što su AIFF, FLAC ili WAV. Naš alat za mastering će uvijek vratiti isti tip datoteke kao originalna datoteka. Imajte na umu da vam je potreban 16-bitni, 44.1 khz WAV datoteka za distribuciju.",
            "errorSongNameRequired": "Molimo unesite ime pjesme",
            "errorSongNameLength": "Ime pjesme ne smije biti duže od 80 znakova.",
            "errorGenreRequired": "Molimo unesite žanr pjesme",
            "errorGenreLength": "Žanr pjesme ne smije biti duži od 50 znakova.",
            "errorPresetRequired": "Preset mora biti odabran.",
            "errorAudioFileRequired": "Molimo odaberite datoteku pjesme",
            "errorAudioFileValid": "Molimo prenesite važeću audio datoteku"
        }
    },
    "masteringConfirmModal": {
        "header": "Jeste li sigurni da želite spremiti Audio Mastering?",
        "body": "Napomena: Molimo provjerite da ste prenijeli ispravne audio datoteke jer ih nije moguće mijenjati nakon spremanja.",
        "button": {
            "cancel": "Otkaži",
            "confirm": "Potvrdi"
        },
        "message": {
            "error": "Nešto je pošlo po zlu! Molimo osvježite stranicu i pokušajte ponovno!"
        }
    }
};

export default masteringHR;